module.exports = __webpack_public_path__ + "img/back-arrow.4181ae0b.svg";